module.exports = "<i class=\"fa fa-spinner system-status-in-progress\" title={{value}}></i>";